import { render, staticRenderFns } from "./StarterPage.vue?vue&type=template&id=18d4dc62&"
import script from "./StarterPage.vue?vue&type=script&lang=js&"
export * from "./StarterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports